import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson23: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson22"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">
            Practical Tips For Weight Loss
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson24"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-justify text-white font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            <span>
              <span>
                We’ll dive more into weight loss in Cutting weight section.
              </span>
            </span>
          </p>
          <p className="m-0 text-[1.88rem]">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-white">
            <b>
              <span>&nbsp;</span>
            </b>
          </p>
          <ul className="m-0 text-[1.88rem] pl-[2.5rem]">
            <li className="mb-[0rem]">
              <b>
                <span>Balanced Meal Composition</span>
              </b>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Your meals should be a balance of protein, fats, vegetables, and
            complex carbs. Adults typically need 5-7 ounces of protein, 2-5 cups
            of vegetables, 22-44 grams of healthy oils, and 5-10 ounces of
            grains daily. Eating enough protein helps maintain muscle mass
            during weight loss and keeps you full. Include a variety of
            vegetables and moderate healthy fats, such as olive oil and nuts,
            while being mindful of high-calorie items like butter and coconut
            oil.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-[1.5rem] pl-[2.5rem] text-white">
            <li className="mb-[0rem]">
              <b>Physical Activity</b>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            A mix of cardiovascular exercises and strength training is
            recommended for overall health. Activities like walking, running,
            cycling, and weightlifting can complement your weight loss goals.
            Always consult a doctor before starting a new workout regime.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-[1.5rem] pl-[2.5rem] text-white">
            <li className="mb-[0rem]">
              <b>Fiber Intake</b>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Fiber helps you feel full longer, stabilizes blood sugar, and
            supports digestion. Incorporate fiber-rich foods such as fruits,
            vegetables, whole grains, and legumes into your diet, aiming for 2
            cups of fruit and 6 ounces of grains daily.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-[1.5rem] pl-[2.5rem] text-white">
            <li className="mb-[0rem]">
              <b>Mindful Eating</b>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Eating slowly and recognizing your hunger cues can prevent
            overeating. Minimize distractions during meals and focus on the
            experience of eating to help you recognize when you're truly full.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-[1.5rem] pl-[2.5rem] text-white">
            <li className="mb-[0rem]">
              <b>
                <span>Hydration</span>
              </b>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Drinking water can reduce appetite and enhance fat burning. Opt
                for water or low-calorie drinks instead of sugary beverages to
                aid in weight management.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 text-[1.5rem] pl-[2.5rem] text-white">
            <li className="mb-[0rem]">
              <b>Adequate Sleep</b>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Getting at least 7 hours of sleep per night is associated with a
            lower risk of obesity and can help regulate hunger hormones.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Portion Control</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                While calorie counting isn't necessary for everyone, being aware
                of portion sizes can be helpful if you're not losing weight.
                Reducing calorie intake should be done based on a doctor's
                advice to avoid unhealthy weight loss practices.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b>
              <span>Meal Ideas</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Nutritious meals for weight loss might include a poached egg
                with avocado, baked salmon with vegetables, or a spinach and
                feta quiche. Aim for a mixture of protein, healthy fats, and
                complex carbs.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-orangered-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b>
              <span>Weight Loss Pace</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Safe weight loss is about 0.5-2 pounds per week. Initial faster
                weight loss can occur due to water weight and body fat changes,
                but sustainable weight loss takes time.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-orangered-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b>
              <span>Quick Weight Loss Concerns</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                While rapid weight loss methods exist, they're often
                unsustainable and potentially unhealthy. Slower, consistent
                weight loss is more effective for long-term results.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-orangered-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <b>
              <span>Sustainable Practices</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Remember, quick fixes might not offer long-term results.
                Focusing on balanced eating and regular physical activity is key
                to sustainable weight loss. For specific health concerns or diet
                plans, consult with a healthcare professional.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In summary, a balanced diet, regular exercise, mindful eating,
                proper hydration, and sufficient sleep form the pillars of a
                sustainable weight loss plan. Aim for gradual progress rather
                than immediate results for healthier and more enduring outcomes.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>
                <span>Nutritional Guidelines</span>
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <b>
              <span>
                <span>&nbsp;</span>
              </span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b>
                <span>Breakfast:</span>
              </b>
            </span>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Protein:</b>
                  <span> Scrambled eggs (2-3) or Greek yogurt (1 cup)</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Healthy fats: `}</b>
                  <span className="font-dm-sans">
                    Avocado (1/2 fruit) or a handful of almonds
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Vegetables: `}</b>
                  <span className="font-dm-sans">
                    Spinach or kale (1 cup cooked or raw)
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Complex carbs: `}</b>
                  <span>Oatmeal (1/2 cup dry) with cinnamon for flavor</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0 text-orangered-100">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>
                <span>Lunch:</span>
              </b>
            </span>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Protein:</b>
                  <span>
                    {" "}
                    Grilled chicken breast (3-4 oz) or chickpeas (1/2 cup)
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Healthy fats:</b>
                  <span className="font-dm-sans">
                    {" "}
                    Olive oil dressing (1 tablespoon) on salad
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Vegetables: `}</b>
                  <span className="font-dm-sans">
                    Mixed greens salad (2 cups) with tomatoes, cucumbers, and
                    carrots
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Complex carbs:</b>
                  <span>
                    {" "}
                    Quinoa (1/2 cup cooked) or sweet potato (1/2 medium)
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0 text-orangered-100">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>
                <span>Dinner:</span>
              </b>
            </span>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Protein:</b>
                  <span> Baked salmon (4 oz) or tofu (1/2 cup)</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Healthy fats: `}</b>
                  <span className="font-dm-sans">
                    Sautéed vegetables in olive oil (1 tablespoon)
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Vegetables: `}</b>
                  <span className="font-dm-sans">
                    Steamed broccoli or asparagus (1-2 cups)
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Complex carbs:</b>
                  <span>
                    {" "}
                    Brown rice (1/2 cup cooked) or whole-grain pasta (1/2 cup
                    cooked)
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0 text-orangered-100">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>
                <span>Snacks:</span>
              </b>
            </span>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Protein and fats:</b>
                  <span> A small handful of nuts or seeds</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Fiber:</b>
                  <span className="font-dm-sans">
                    {" "}
                    Fresh fruit like an apple or a cup of berries
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Hydration:</b>
                  <span className="font-dm-sans">
                    {" "}
                    Water, herbal tea, or a cup of broth
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>
                <span>Exercise Routine</span>
              </b>
            </span>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>{`Monday: `}</b>
                  <span>Cardio - 30-minute brisk walk or jog</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Tuesday: `}</b>
                  <span className="font-dm-sans">
                    Strength training - Bodyweight exercises or gym session
                    focusing on major muscle groups
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Wednesday: `}</b>
                  <span className="font-dm-sans">
                    Active recovery - Yoga or stretching for 30 minutes
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Thursday: `}</b>
                  <span className="font-dm-sans">
                    Cardio - 20 minutes of high-intensity interval training
                    (HIIT)
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Friday: `}</b>
                  <span className="font-dm-sans">
                    Strength training - Resistance band workouts or
                    weightlifting
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Saturday:</b>
                  <span className="font-dm-sans">
                    {" "}
                    Leisure activity - Hiking, cycling, or playing a sport
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Sunday:</b>
                  <span> Rest or gentle walk to stay active</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Note: Before starting any new exercise regimen, consult with a
                  healthcare provider or fitness professional, especially if you
                  have any pre-existing health conditions.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>Lifestyle Adjustments</b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>
                <span>Mindful Eating Practices:</span>
              </b>
            </span>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>{`Chew slowly: `}</b>
                  <span>
                    Take at least 20 minutes to finish a meal to help your brain
                    recognize fullness signals.
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Portion awareness:</b>
                  <span className="font-dm-sans">
                    {" "}
                    Use smaller plates or bowls to naturally reduce portion
                    sizes without feeling deprived.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>
                <span>Hydration:</span>
              </b>
            </span>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Before meals:</b>
                  <span>
                    {" "}
                    Drink a glass of water 30 minutes before eating to aid
                    digestion and control hunger.
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Throughout the day: `}</b>
                  <span>Keep a water bottle handy and sip regularly.</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>Sleep:</b>
            </span>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Consistency:</b>
                  <span>
                    {" "}
                    Aim to go to bed and wake up at the same time every day.
                  </span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Environment: `}</b>
                  <span>
                    Ensure your bedroom is dark, quiet, and cool to promote
                    restful sleep.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>
                <span>Stress Management:</span>
              </b>
            </span>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>{`Daily practice: `}</b>
                  <span>
                    Engage in stress-reducing activities such as meditation,
                    deep breathing, or reading.
                  </span>
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  <b className="font-dm-sans">Professional help:</b>
                  <span className="font-dm-sans">
                    {" "}
                    Consider therapy or counseling if stress is a significant
                    factor in your life.
                  </span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>Monitoring Progress</b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Track food intake:</b>
                <span>
                  {" "}
                  Consider using a food diary app to record your meals and
                  ensure you're meeting your nutritional goals without
                  overeating.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">Measure your exercise:</b>
                <span className="font-dm-sans">
                  {" "}
                  Use a fitness tracker or app to record your workouts and
                  activity levels.
                </span>
              </span>
            </li>
            <li>
              <span>
                <b className="font-dm-sans">Regular check-ins:</b>
                <span className="font-dm-sans">
                  {" "}
                  Weigh yourself weekly at the same time of day, and also take
                  monthly body measurements to track changes beyond the scale.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>Support and Motivation</b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Community: `}</b>
                <span>
                  Join a weight loss group or find a workout buddy to stay
                  motivated.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <b className="font-dm-sans">{`Professional guidance: `}</b>
                <span className="font-dm-sans">
                  Consider a consultation with a dietitian for personalized
                  dietary advice and a trainer for customized workout plans.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                By following this detailed plan, you're setting yourself up for
                a sustainable and healthy weight loss journey. Remember, the key
                to long-term success is consistency and a balanced approach that
                fits your lifestyle and preferences.
              </span>
            </span>
          </p>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson24"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
      </div>
    </div>
  );
};

export default Lesson23;
